export const MOBILE_MAX_LENGTH = 10;

export function limitMobileInput(value, maxLength = MOBILE_MAX_LENGTH) {
	return String(value ?? "").replace(/\D/g, "").slice(0, maxLength);
}
